// 防抖
import type { DictItem, TreeItem } from '@/types'
import { computed, ref } from 'vue'

export function debounce(func: Function, delay: number) {
  let timer: NodeJS.Timeout

  return function <T>(this: T, ...args: any[]) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function dictLabel(v: string, list: DictItem[]) {
  const target = list.find((item) => item.value === v)
  return target?.label ?? ''
}

export function dictCache(list: TreeItem[], deep: number = 1) {
  const result: { [p: string | number]: string } = {}

  function deepFn(list: TreeItem[], deep: number) {
    list.forEach((item) => {
      if (deep > 0) {
        deepFn(item.children || [], deep - 1)
      } else {
        Reflect.set(result, item.value, item.label)
      }
    })
  }

  deepFn(list, deep - 1)
  return result
}

export function dictCacheIndex(list: TreeItem[], deep: number = 1) {
  const result: { [p: string | number]: string } = {}

  function deepFn(list: TreeItem[], indexes: number[], deep: number) {
    list.forEach((item, index) => {
      const tmp = [...indexes, index]
      if (deep > 0) {
        deepFn(item.children || [], tmp, deep - 1)
      } else {
        Reflect.set(result, item.value, tmp.join('-'))
      }
    })
  }

  deepFn(list, [], deep - 1)
  return result
}

export function wait(delay?: number) {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), delay)
  })
}

export function removeRepeat<T>(arr: T[]) {
  return Array.from(new Set(arr))
}

type RejectReasonType = 'countLimitReject'
export function createRequestQueue(len: number, rejectCallback?: (rejectReason: RejectReasonType) => any) {
  const count = ref(0)
  const working = computed(() => count.value > 0)
  return {
    working,
    requestQueue: async <T>(func: () => Promise<T>) => {
      if (count.value >= len) {
        rejectCallback?.('countLimitReject')
        return Promise.reject('countLimitReject')
      }
      count.value += 1
      const promise = func()
      await promise.finally(() => (count.value -= 1))
      return promise
    },
  }
}
